/* eslint-disable @typescript-eslint/naming-convention */
const authRoutes = {
  base: "/",
  wellevate_practitioner_sign_up: "/wellevate/practitioner-signup",
  wellevate_patients_authorize: "/wellevate/patients/authorize",
  emerson_ecologics_practitioner_sign_up: "/emerson-ecologics/practitioner-signup",
  practitioner_sign_up: "/practitioner-signup",
  patient_sign_up: "/patient-signup",
  login: "/login",
  forgot_password: "/password",
  edit_password: "/edit_password",
  usApp: "https://us.fullscript.com",
  caApp: "https://ca.fullscript.com",
  rx_sign_in: "/welcome/:practitionerSlug/:tpSlug",
  rx_sign_in_forgot_password: (practitionerSlug = ":practitionerSlug", tpSlug = ":tpSlug") =>
    `/welcome/${practitionerSlug}/${tpSlug}/forgot-password`,
  rx_sign_up: (practitionerSlug = ":practitionerSlug", tpSlug = ":tpSlug") =>
    `/welcome/${practitionerSlug}/${tpSlug}/signup`,
  welcome_sign_up: (storeSlug = ":storeSlug", isPreview = false) =>
    getWelcomeURL(storeSlug, null, `signup${isPreview ? "?preview=true" : ""}`),
  welcome_sign_in: (storeSlug = ":storeSlug", identitySlug) =>
    getWelcomeURL(storeSlug, identitySlug, "signin"),
  welcome_activation: (storeSlug = ":storeSlug", identitySlug) =>
    getWelcomeURL(storeSlug, identitySlug, "activation"),
  welcome_forgot_password: (storeSlug = ":storeSlug", identitySlug) =>
    getWelcomeURL(storeSlug, identitySlug, "forgot-password"),
} as const;

/** welcome path has two paths, but render the same page */
const getWelcomeURL = (storeSlug, identitySlug, endPath) =>
  identitySlug
    ? `/welcome/${storeSlug}/${identitySlug}/${endPath}`
    : `/welcome/${storeSlug}/${endPath}`;

export { authRoutes };
